import type { Metadata } from "next";
import AdBanner from "@/Component/Admin/AdBanner";

export const metadata: Metadata = {
    title: "Advertisement Banner | Connector Club",
};

const AdBannerPage = () => {
  return (
    <AdBanner />
  )
}

export default AdBannerPage
